// extracted by mini-css-extract-plugin
module.exports = {"root":"galaxy_root__3fz4_"};